import { SvgIcons } from '@ngneat/svg-icon';

import { VehicleOperationalStatusStoreModelEnum } from '@domain/single-site/single-site.enums';

export const VEHICLE_STATUS_PROPERTIES_MAP: Record<
  VehicleOperationalStatusStoreModelEnum,
  {
    iconName16: SvgIcons;
    iconName40: SvgIcons;
    bgColorClass: string;
    fillColorClass: string;
    borderColorClass: string;
    textColorClass: string;
    dropShadowClass: string;
  }
> = {
  [VehicleOperationalStatusStoreModelEnum.Ready]: {
    iconName16: 'ready-16',
    iconName40: 'ready-40',
    bgColorClass: 'bg-chargingstatus-ready-100',
    fillColorClass: 'fill-chargingstatus-ready-100',
    borderColorClass: 'border-chargingstatus-ready-100',
    textColorClass: 'text-chargingstatus-ready-100',
    dropShadowClass: 'drop-shadow-chargingstatus-ready-100-shadow-30',
  },
  [VehicleOperationalStatusStoreModelEnum.Charging]: {
    iconName16: 'charging-16',
    iconName40: 'charging-40',
    bgColorClass: 'bg-chargingstatus-charging-100',
    fillColorClass: 'fill-chargingstatus-charging-100',
    borderColorClass: 'border-chargingstatus-charging-100',
    textColorClass: 'text-chargingstatus-charging-100',
    dropShadowClass: 'drop-shadow-chargingstatus-charging-100-shadow-30',
  },
  [VehicleOperationalStatusStoreModelEnum.Queued]: {
    iconName16: 'queued-16',
    iconName40: 'queued-40',
    bgColorClass: 'bg-chargingstatus-queued-100',
    fillColorClass: 'fill-chargingstatus-queued-100',
    borderColorClass: 'border-chargingstatus-queued-100',
    textColorClass: 'text-chargingstatus-queued-100',
    dropShadowClass: 'drop-shadow-chargingstatus-queued-100-shadow-30',
  },
  [VehicleOperationalStatusStoreModelEnum.Faulted]: {
    iconName16: 'faulted-16',
    iconName40: 'faulted-40',
    bgColorClass: 'bg-chargingstatus-faulted-100',
    fillColorClass: 'fill-chargingstatus-faulted-100',
    borderColorClass: 'border-chargingstatus-faulted-100',
    textColorClass: 'text-chargingstatus-faulted-100',
    dropShadowClass: 'drop-shadow-chargingstatus-faulted-100-shadow-30',
  },
  [VehicleOperationalStatusStoreModelEnum.InDepot]: {
    iconName16: 'in-depot-16',
    iconName40: 'in-depot-40',
    bgColorClass: 'bg-chargingstatus-indepot-100',
    fillColorClass: 'fill-chargingstatus-indepot-100',
    borderColorClass: 'border-chargingstatus-indepot-100',
    textColorClass: 'text-chargingstatus-indepot-100',
    dropShadowClass: 'drop-shadow-chargingstatus-indepot-100-shadow-30',
  },
  [VehicleOperationalStatusStoreModelEnum.OnTheRoad]: {
    iconName16: 'on-the-road-16',
    iconName40: 'on-the-road-40',
    bgColorClass: 'bg-chargingstatus-onroad-100',
    fillColorClass: 'fill-chargingstatus-onroad-100',
    borderColorClass: 'border-chargingstatus-onroad-100',
    textColorClass: 'text-chargingstatus-onroad-100',
    dropShadowClass: 'drop-shadow-chargingstatus-onroad-100-shadow-30',
  },
  [VehicleOperationalStatusStoreModelEnum.Unknown]: {
    iconName16: 'unknown-16',
    iconName40: 'unknown-40',
    bgColorClass: 'bg-foreground-primary-100 dark:bg-foreground-secondary-100',
    fillColorClass: 'fill-foreground-primary-80',
    borderColorClass: 'border-foreground-primary-100 dark:border-foreground-secondary-100',
    textColorClass: 'text-foreground-primary-100',
    dropShadowClass: 'drop-shadow-foreground-primary-100-shadow-30',
  },
};
